<div>
  <h1 class="text-center">Ooops happend! Sorry...!</h1>

  <div class="alert alert-danger" role="alert" *ngIf="!isEmpty(apiService.getParam('message'))"
       [innerHTML]="apiService.getParam('message')"></div>
</div>
